(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('rxjs'), require('rxjs/operators'), require('@material/ripple'), require('@material/top-app-bar')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/top-app-bar', ['exports', '@angular/core', '@angular/common', '@angular/cdk/coercion', '@angular/cdk/platform', 'rxjs', 'rxjs/operators', '@material/ripple', '@material/top-app-bar'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.topAppBar = {}), global.ng.core, global.ng.common, global.ng.cdk.coercion, global.ng.cdk.platform, global.rxjs, global.rxjs.operators, global.mdc.ripple, global.mdc.topAppBar));
}(this, (function (exports, core, common, coercion, platform, rxjs, operators, ripple, topAppBar) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: core.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: core.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: core.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: core.Input }],
            primary: [{ type: core.Input }],
            secondary: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            unbounded: [{ type: core.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcTopAppBarFixedAdjust = /** @class */ (function () {
        function MdcTopAppBarFixedAdjust(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTopAppBarFixedAdjust.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcTopAppBarFixedAdjust]',
                        host: { 'class': 'mdc-top-app-bar--fixed-adjust' }
                    },] }
        ];
        /** @nocollapse */
        MdcTopAppBarFixedAdjust.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcTopAppBarFixedAdjust;
    }());
    var MdcTopAppBarRow = /** @class */ (function () {
        function MdcTopAppBarRow(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTopAppBarRow.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-top-app-bar-row, [mdcTopAppBarRow]',
                        exportAs: 'mdcTopAppBarRow',
                        host: { 'class': 'mdc-top-app-bar__row' }
                    },] }
        ];
        /** @nocollapse */
        MdcTopAppBarRow.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcTopAppBarRow;
    }());
    var MdcTopAppBarSection = /** @class */ (function () {
        function MdcTopAppBarSection(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTopAppBarSection.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-top-app-bar-section, [mdcTopAppBarSection]',
                        exportAs: 'mdcTopAppBarSection',
                        host: {
                            'role': 'toolbar',
                            'class': 'mdc-top-app-bar__section',
                            '[class.mdc-top-app-bar__section--align-start]': 'align === "start"',
                            '[class.mdc-top-app-bar__section--align-end]': 'align === "end"'
                        },
                        template: "\n  <ng-content></ng-content>\n  <span class=\"mdc-top-app-bar__title\" *ngIf=\"title\">{{title}}</span>",
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcTopAppBarSection.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcTopAppBarSection.propDecorators = {
            title: [{ type: core.Input }],
            align: [{ type: core.Input }]
        };
        return MdcTopAppBarSection;
    }());
    var MdcTopAppBarActionItem = /** @class */ (function () {
        function MdcTopAppBarActionItem(elementRef, _ripple) {
            this.elementRef = elementRef;
            this._ripple = _ripple;
            this._root = elementRef.nativeElement;
            _ripple = this._createRipple();
            _ripple.init();
        }
        MdcTopAppBarActionItem.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcTopAppBarActionItem.prototype._createRipple = function () {
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { isUnbounded: function () { return true; } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcTopAppBarActionItem.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcTopAppBarActionItem], mdc-top-app-bar-action-item',
                        exportAs: 'mdcTopAppBarActionItem',
                        host: {
                            'role': 'button',
                            'class': 'mdc-top-app-bar__action-item mdc-icon-button'
                        },
                        providers: [MdcRipple]
                    },] }
        ];
        /** @nocollapse */
        MdcTopAppBarActionItem.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: MdcRipple }
        ]; };
        return MdcTopAppBarActionItem;
    }());
    var MdcTopAppBarNavigationIcon = /** @class */ (function () {
        function MdcTopAppBarNavigationIcon(elementRef, _ripple) {
            this.elementRef = elementRef;
            this._ripple = _ripple;
            this._root = elementRef.nativeElement;
            _ripple = this._createRipple();
            _ripple.init();
        }
        MdcTopAppBarNavigationIcon.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcTopAppBarNavigationIcon.prototype._createRipple = function () {
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { isUnbounded: function () { return true; } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcTopAppBarNavigationIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcTopAppBarNavIcon], mdc-icon[mdcTopAppBarNavigationIcon]',
                        exportAs: 'mdcTopAppBarNavigationIcon',
                        host: {
                            'role': 'button',
                            'class': 'mdc-top-app-bar__navigation-icon mdc-icon-button'
                        },
                        providers: [MdcRipple]
                    },] }
        ];
        /** @nocollapse */
        MdcTopAppBarNavigationIcon.ctorParameters = function () { return [
            { type: core.ElementRef },
            { type: MdcRipple }
        ]; };
        return MdcTopAppBarNavigationIcon;
    }());
    var MdcTopAppBarTitle = /** @class */ (function () {
        function MdcTopAppBarTitle(elementRef) {
            this.elementRef = elementRef;
        }
        MdcTopAppBarTitle.decorators = [
            { type: core.Directive, args: [{
                        selector: 'mdc-top-app-bar-title, [mdcTopAppBarTitle]',
                        exportAs: 'mdcTopAppBarTitle',
                        host: { 'class': 'mdc-top-app-bar__title' },
                    },] }
        ];
        /** @nocollapse */
        MdcTopAppBarTitle.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcTopAppBarTitle;
    }());

    /** Event object emitted by MdcTopAppBar navigation icon selected. */
    var MdcTopAppBarNavSelected = /** @class */ (function () {
        function MdcTopAppBarNavSelected(source) {
            this.source = source;
        }
        return MdcTopAppBarNavSelected;
    }());
    var MdcTopAppBar = /** @class */ (function (_super) {
        __extends(MdcTopAppBar, _super);
        function MdcTopAppBar(_ngZone, _platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._fixed = false;
            _this._prominent = false;
            _this._short = false;
            _this._shortCollapsed = false;
            _this._dense = false;
            _this._fixedAdjustElement = null;
            _this._scrollTarget = _this._platform.isBrowser ? _this.scrollTarget || window : undefined;
            /** Event emitted when the navigation icon is selected. */
            _this.navigationSelected = new core.EventEmitter();
            _this._scrollTargetSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcTopAppBar.prototype, "fixed", {
            get: function () { return this._fixed; },
            set: function (value) {
                if (value !== this._fixed) {
                    this.setFixed(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "prominent", {
            get: function () { return this._prominent; },
            set: function (value) {
                if (value !== this._prominent) {
                    this.setProminent(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "short", {
            get: function () { return this._short; },
            set: function (value) {
                if (value !== this._short) {
                    this.setShort(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "shortCollapsed", {
            get: function () { return this._shortCollapsed; },
            set: function (value) {
                if (value !== this._shortCollapsed) {
                    this.setShortCollapsed(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "dense", {
            get: function () { return this._dense; },
            set: function (value) {
                if (value !== this._dense) {
                    this.setDense(value);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "fixedAdjustElement", {
            get: function () { return this._fixedAdjustElement; },
            set: function (element) {
                if (this._fixedAdjustElement !== element) {
                    this._fixedAdjustElement = element;
                    this._initTopAppBar();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcTopAppBar.prototype, "scrollTarget", {
            get: function () { return this._scrollTarget; },
            set: function (target) {
                if (target !== this._scrollTarget) {
                    this._scrollTarget = target ? target : this._platform.isBrowser ? window : undefined;
                    this._initScrollHandler();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcTopAppBar.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) {
                    if (className === topAppBar.cssClasses.SHORT_COLLAPSED_CLASS && _this.shortCollapsed) {
                        return;
                    }
                    _this._getHostElement().classList.remove(className);
                },
                setStyle: function (property, value) { return _this._getHostElement().style.setProperty(property, value); },
                getTopAppBarHeight: function () { return _this._getHostElement().clientHeight; },
                notifyNavigationIconClicked: function () { return _this.navigationSelected.emit({ source: _this }); },
                getViewportScrollY: function () {
                    if (!_this._platform.isBrowser) {
                        return 0;
                    }
                    return _this._scrollTarget[_this._scrollTarget === window ? 'pageYOffset' : 'scrollTop'];
                },
                getTotalActionItems: function () { return _this.actions ? _this.actions.length : 0; }
            };
            var foundation;
            if (!this.elementRef) {
                return new topAppBar.MDCTopAppBarBaseFoundation(adapter);
            }
            if (this.short) {
                foundation = new topAppBar.MDCShortTopAppBarFoundation(adapter);
            }
            else if (this.fixed) {
                foundation = new topAppBar.MDCFixedTopAppBarFoundation(adapter);
            }
            else {
                foundation = new topAppBar.MDCTopAppBarFoundation(adapter);
            }
            return foundation;
        };
        MdcTopAppBar.prototype.ngAfterContentInit = function () {
            var _this = this;
            this.actions.changes.pipe(operators.startWith(null), operators.takeUntil(this._destroyed))
                .subscribe(function () {
                if (_this.short && _this.actions.length) {
                    _this._getHostElement().classList.toggle(topAppBar.cssClasses.SHORT_HAS_ACTION_ITEM_CLASS);
                }
            });
        };
        MdcTopAppBar.prototype.ngAfterViewInit = function () {
            this._initFoundation();
        };
        MdcTopAppBar.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            if (this._scrollTargetSubscription) {
                this._scrollTargetSubscription.unsubscribe();
            }
            this._destroyFoundation();
        };
        /** Sets the top app bar to fixed or not. */
        MdcTopAppBar.prototype.setFixed = function (fixed, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._fixed = coercion.coerceBooleanProperty(fixed);
            if (this.fixed && this.short) {
                this.setShort(false);
            }
            if (isUserInput) {
                this._initFoundation();
            }
        };
        /** Sets the top app bar to prominent or not. */
        MdcTopAppBar.prototype.setProminent = function (prominent, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._prominent = coercion.coerceBooleanProperty(prominent);
            if (this.prominent && this.short) {
                this.setShort(false);
            }
            if (isUserInput) {
                this._initFoundation();
            }
        };
        /** Sets the top app bar to dense variant. */
        MdcTopAppBar.prototype.setDense = function (dense, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._dense = coercion.coerceBooleanProperty(dense);
            if (this.dense && this.short) {
                this.setShort(false);
            }
            if (isUserInput) {
                this._initFoundation();
            }
        };
        /** Sets the top app bar to short or not. */
        MdcTopAppBar.prototype.setShort = function (short, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._short = coercion.coerceBooleanProperty(short);
            if (this.short) {
                this.setProminent(false);
                this.setDense(false);
                this.setFixed(false);
            }
            else {
                this.setShortCollapsed(false);
            }
            if (isUserInput) {
                this._initFoundation();
            }
        };
        /** Sets the top app bar to short-collapsed or not. */
        MdcTopAppBar.prototype.setShortCollapsed = function (shortCollapsed, isUserInput) {
            if (isUserInput === void 0) { isUserInput = false; }
            this._shortCollapsed = coercion.coerceBooleanProperty(shortCollapsed);
            if (this.shortCollapsed && !this.short) {
                this.setShort(true);
            }
            if (isUserInput) {
                this._initFoundation();
            }
        };
        MdcTopAppBar.prototype.isCollapsed = function () {
            return this._getHostElement().classList.contains(topAppBar.cssClasses.SHORT_COLLAPSED_CLASS);
        };
        MdcTopAppBar.prototype._initFoundation = function () {
            this._destroyFoundation();
            this._getHostElement().style.top = '0px';
            this._resetFixedShort();
            this._foundation = this.getDefaultFoundation();
            this._foundation.init();
            this._initTopAppBar();
            this._initScrollHandler();
            this._changeDetectorRef.markForCheck();
        };
        MdcTopAppBar.prototype._resetFixedShort = function () {
            this._getHostElement().classList.remove(topAppBar.cssClasses.SHORT_HAS_ACTION_ITEM_CLASS);
            this._getHostElement().classList.remove(topAppBar.cssClasses.SHORT_COLLAPSED_CLASS);
            this._getHostElement().classList.remove(topAppBar.cssClasses.FIXED_SCROLLED_CLASS);
        };
        MdcTopAppBar.prototype._initTopAppBar = function () {
            if (!this.fixed) {
                this._getHostElement().classList.remove(topAppBar.cssClasses.FIXED_SCROLLED_CLASS);
            }
            if (this.fixed && this._getScrollOffset() > 0) {
                this._getHostElement().classList.add(topAppBar.cssClasses.FIXED_SCROLLED_CLASS);
            }
            if (!this.short) {
                this._getHostElement().classList.remove(topAppBar.cssClasses.SHORT_HAS_ACTION_ITEM_CLASS);
                this._getHostElement().classList.remove(topAppBar.cssClasses.SHORT_COLLAPSED_CLASS);
            }
            if (this.short && this._getScrollOffset() > 0) {
                this._getHostElement().classList.add(topAppBar.cssClasses.SHORT_COLLAPSED_CLASS);
            }
            if (this.shortCollapsed) {
                this._getHostElement().classList.add(topAppBar.cssClasses.SHORT_COLLAPSED_CLASS);
            }
            if (this.fixedAdjustElement) {
                this._removeFixedAdjustClasses();
                this._addFixedAdjustClass();
            }
        };
        MdcTopAppBar.prototype._removeFixedAdjustClasses = function () {
            this.fixedAdjustElement.classList.remove('mdc-top-app-bar--short-fixed-adjust');
            this.fixedAdjustElement.classList.remove('mdc-top-app-bar--fixed-adjust');
            this.fixedAdjustElement.classList.remove('mdc-top-app-bar--dense-fixed-adjust');
            this.fixedAdjustElement.classList.remove('mdc-top-app-bar--prominent-fixed-adjust');
            this.fixedAdjustElement.classList.remove('mdc-top-app-bar--dense-prominent-fixed-adjust');
        };
        MdcTopAppBar.prototype._addFixedAdjustClass = function () {
            if (this._short) {
                this.fixedAdjustElement.classList.add('mdc-top-app-bar--short-fixed-adjust');
            }
            else if (this._dense && this._prominent) {
                this.fixedAdjustElement.classList.add('mdc-top-app-bar--dense-prominent-fixed-adjust');
            }
            else if (this._dense) {
                this.fixedAdjustElement.classList.add('mdc-top-app-bar--dense-fixed-adjust');
            }
            else if (this._prominent) {
                this.fixedAdjustElement.classList.add('mdc-top-app-bar--prominent-fixed-adjust');
            }
            else {
                this.fixedAdjustElement.classList.add('mdc-top-app-bar--fixed-adjust');
            }
        };
        MdcTopAppBar.prototype._destroyFoundation = function () {
            var _a;
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        MdcTopAppBar.prototype._initScrollHandler = function () {
            var _this = this;
            if (this._scrollTargetSubscription) {
                this._scrollTargetSubscription.unsubscribe();
            }
            if (!this._platform.isBrowser) {
                return;
            }
            this._scrollTargetSubscription = this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this.scrollTarget || window, 'scroll')
                    .subscribe(function () { return _this._ngZone.run(function () { return _this._foundation.handleTargetScroll(); }); });
            });
        };
        MdcTopAppBar.prototype._getScrollOffset = function () {
            if (!this._platform.isBrowser) {
                return 0;
            }
            return this.scrollTarget ? this.scrollTarget.scrollTop : window.pageYOffset;
        };
        /** Retrieves the DOM element of the component host. */
        MdcTopAppBar.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcTopAppBar.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-top-app-bar, [mdc-top-app-bar]',
                        exportAs: 'mdcTopAppBar',
                        host: {
                            'class': 'mdc-top-app-bar',
                            '[class.mdc-top-app-bar--prominent]': 'prominent',
                            '[class.mdc-top-app-bar--dense]': 'dense',
                            '[class.mdc-top-app-bar--short]': 'short',
                            '[class.mdc-top-app-bar--fixed]': 'fixed'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcTopAppBar.ctorParameters = function () { return [
            { type: core.NgZone },
            { type: platform.Platform },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef }
        ]; };
        MdcTopAppBar.propDecorators = {
            fixed: [{ type: core.Input }],
            prominent: [{ type: core.Input }],
            short: [{ type: core.Input }],
            shortCollapsed: [{ type: core.Input }],
            dense: [{ type: core.Input }],
            fixedAdjustElement: [{ type: core.Input }],
            scrollTarget: [{ type: core.Input }],
            navigationSelected: [{ type: core.Output }],
            navigationIcon: [{ type: core.ContentChild, args: [MdcTopAppBarNavigationIcon, { static: false },] }],
            actions: [{ type: core.ContentChildren, args: [MdcTopAppBarActionItem, { descendants: true },] }]
        };
        return MdcTopAppBar;
    }(MDCComponent));

    var TOP_APP_BAR_DECLARATIONS = [
        MdcTopAppBar,
        MdcTopAppBarActionItem,
        MdcTopAppBarFixedAdjust,
        MdcTopAppBarNavigationIcon,
        MdcTopAppBarRow,
        MdcTopAppBarSection,
        MdcTopAppBarTitle
    ];
    var MdcTopAppBarModule = /** @class */ (function () {
        function MdcTopAppBarModule() {
        }
        MdcTopAppBarModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: TOP_APP_BAR_DECLARATIONS,
                        declarations: TOP_APP_BAR_DECLARATIONS
                    },] }
        ];
        return MdcTopAppBarModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcTopAppBar = MdcTopAppBar;
    exports.MdcTopAppBarActionItem = MdcTopAppBarActionItem;
    exports.MdcTopAppBarFixedAdjust = MdcTopAppBarFixedAdjust;
    exports.MdcTopAppBarModule = MdcTopAppBarModule;
    exports.MdcTopAppBarNavSelected = MdcTopAppBarNavSelected;
    exports.MdcTopAppBarNavigationIcon = MdcTopAppBarNavigationIcon;
    exports.MdcTopAppBarRow = MdcTopAppBarRow;
    exports.MdcTopAppBarSection = MdcTopAppBarSection;
    exports.MdcTopAppBarTitle = MdcTopAppBarTitle;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-top-app-bar.umd.js.map
